import React from "react";
import { RolesAndPermissionsContainer } from "./RolesAndPermissions.styled";

const RolesAndPermissions = () => {
  return (
    <RolesAndPermissionsContainer>
      <h2>Roles and Permissions</h2>
      <p>User roles and permissions will be displayed here.</p>
    </RolesAndPermissionsContainer>
  );
};

export default RolesAndPermissions;

